<h1 mat-dialog-title>Add Competencies</h1>
<div mat-dialog-content>
    <div>
        <mat-label class="h5 label-bold">Competency</mat-label>
        <mat-select  #filetype class="form-control custom-mat-single-select file-type fs-14 black-clr" placeholder="Select"
            [(value)]="competencySelected" (selectionChange)="onCompetencyChange($event)">
            <mat-option *ngFor="let line of serviceLines" [value]="line">{{line.name}}</mat-option>
        </mat-select>
    </div><br />
    <mat-label class="h5 label-bold">Sub Competency</mat-label>
    <mat-select class="custom-mat-single-select form-control file-type fs-14 multi-select" placeholder="Select"
        [formControl]="subCompetencyControl" [compareWith]="compareThem" multiple>
        <mat-select-trigger>
            <mat-chip-list>
                <mat-chip *ngFor="let competency of subCompetencyControl.value" [removable]="true"
                    (removed)="onSubCompetencyRemoved(competency)">
                    {{competency.name }}
                    <mat-icon matChipRemove *ngIf="!competency.isDefault">cancel</mat-icon>
                </mat-chip>
            </mat-chip-list>
        </mat-select-trigger>
        <ng-container *ngFor="let line of subServiceValues">
            <mat-option [value]="line" [hidden]="line.isDefault">
                <span>{{line.name}}</span>
            </mat-option>
        </ng-container>
    </mat-select>
</div>
<div mat-dialog-actions class="closebtn justify-content-end">
    <button mat-dialog-close class="ml-2 mr-2 custom_btn inverted_btn_base">Cancel</button>
    <button (click)="closeDialog()" [disabled]="subCompetencyControl.value.length==0"
        class="custom_btn primary_btn_base d-flex align-items-center ml-2">Save</button>
</div>